import { useEffect, useState } from "react";
import {
  Accordion,
  Row,
  Col,
  Spinner,
  Alert,
  Modal,
  Form,
} from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { AxiosInstance } from "../../axios"; // Assuming this is your Axios instance
import Cookies from "js-cookie"; // Import Cookies library to get user_id
import Buttons from "../../components/buttons/Buttons";
import ToastMessage from "../../components/messagetoast/ToastMessage"; // Assuming this is your custom ToastMessage
import { Download } from "../../controller/Images";
const Candidates_View = () => {
  const { state } = useLocation();
  const { email, job_id } = state || {};

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeKeys, setActiveKeys] = useState(["0", "1", "2"]);

  const [showCandidateStatusModal, setShowCandidateStatusModal] =
    useState(false);
  const [selectedCandidateStatus, setSelectedCandidateStatus] = useState("");

  const [toast, setToast] = useState({
    show: false,
    message: "",
    variant: "success", // 'success', 'danger', 'warning', 'info'
  });

  // Base URL for downloads
  const API_BASE_URL = AxiosInstance.defaults.baseURL;

  // Mapping for status display and payload value
  const statusMap = {
    // Pending: 0,
    Reviewing: 1,
    Shortlisted: 2,
    Scheduled: 3,
    "On Hold": 4,
    Offered: 5,
    Rejected: 6,
  };

  const statusMapReverse = {
    0: "Pending",
    1: "Reviewing",
    2: "Shortlisted",
    3: "Scheduled",
    4: "On Hold",
    5: "Offered",
    6: "Rejected",
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB");
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!email || !job_id) {
        setError("Missing email or job ID.");
        setLoading(false);
        return;
      }

      try {
        const candidateRes = await AxiosInstance.post(
          "/api/joinourteam/candidate/view",
          { email, job_id },
        );
        const candidate = candidateRes?.data?.Candidate?.[0];

        if (!candidate) {
          setError("Candidate not found.");
          setLoading(false);
          return;
        }

        const jobRes = await AxiosInstance.post("/api/joinourteam/job/view", {
          job_id,
        });
        const job = jobRes?.data?.job;

        const mappedData = {
          job_id: job?.job_id || "-",
          role: job?.role || "-",
          location: job?.location
            ? job.location.charAt(0).toUpperCase() + job.location.slice(1)
            : "-",
          experience: job?.yearof_experience ? `${job.yearof_experience}` : "-",
          work_arrangement:
            Number(job?.work_arrangement) === 1
              ? "Onsite"
              : Number(job?.work_arrangement) === 2
                ? "Remote"
                : "Hybrid",
          posted_date: job?.posted_date ? formatDate(job.posted_date) : "-",
          skills: job?.tag_name || "-",
          department: job?.department_name || "-",
          job_status: job?.job_status === 1 ? "Inactive" : "Active",
          name: candidate.full_name || "-",
          email: candidate.email || "-",
          phone: candidate.phone_number || "-",
          city: candidate.city_name || "-",
          state: candidate.state_name || "-",
          country: candidate.country_name || "-",

          total_experience: candidate.yearof_experience
            ? `${candidate.yearof_experience}`
            : "-",
          relocate: Number(candidate.is_relocated) === 1 ? "Yes" : "No",
          salary: candidate.expected_salary || "-",
          cv: candidate.upload_cv,
          cv_filename: candidate.original_cvpath || "-",
          cover_letter: candidate.upload_coverletter,
          cover_letter_filename: candidate.original_coverletter_path || "-",
          applied_date: formatDate(candidate.applied_date),
          message: candidate.message || "-",
          candidate_status: candidate.status,
        };

        setData(mappedData);
        setSelectedCandidateStatus(
          statusMapReverse[candidate.status] || "Pending",
        );
      } catch (err) {
        console.error(err);
        setError("Failed to fetch candidate or job data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [email, job_id]);

  const toggleAccordion = (key) => {
    setActiveKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );
  };

  const handleCandidateStatusRadioChange = (e) => {
    setSelectedCandidateStatus(e.target.value);
  };

  const handleCloseCandidateStatusModal = () => {
    setShowCandidateStatusModal(false);
    setSelectedCandidateStatus(
      data ? statusMapReverse[data.candidate_status] || "Pending" : "",
    );
  };

  const handleSaveCandidateStatus = async () => {
    const userId = Cookies.get("user_id");
    if (!userId) {
      setToast({
        show: true,
        message: "User ID not found. Please log in again.",
        variant: "danger",
      });
      return;
    }

    const payload = {
      status: statusMap[selectedCandidateStatus],
      email: data.email,
      job_id: data?.job_id,
      updated_by: userId,
      deleted: 0,
    };

    try {
      await AxiosInstance.post("/api/joinourteam/candidate/update", payload);
      setData((prevData) => ({
        ...prevData,
        candidate_status: statusMap[selectedCandidateStatus],
      }));
      setShowCandidateStatusModal(false);
      setToast({
        show: true,
        message: "Candidate status updated successfully!",
        variant: "success",
      });
    } catch (err) {
      console.error("Failed to update candidate status:", err);
      setToast({
        show: true,
        message: "Failed to update candidate status.",
        variant: "danger",
      });
    }
  };

  if (loading) {
    return (
      <div className="text-center p-4">
        {/* <Spinner animation="border" /> Loading... */}
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger" className="m-4">
        {error}
      </Alert>
    );
  }

  const renderField = (label, value, button = null) => (
    <div className="mb-2">
      <div className="d-flex align-items-center">
        <div
          style={{
            fontWeight: 600,
            color: "#142454",
            opacity: 0.6, // 60% opacity
            fontSize: "16px",
          }}
        >
          {label}
        </div>
        {button && <div className="ms-2">{button}</div>}
      </div>
      <div
        style={{
          fontWeight: 600,
          color: "#142454", // full blue color
          fontSize: "18px",
          wordWrap: "break-word",
        }}
      >
        {value}
      </div>
    </div>
  );

  return (
    <>
      <div className="d-flex justify-content-end px-4">
        <Buttons
          variant="outline-secondary"
          size="sm"
          onClick={() => setShowCandidateStatusModal(true)}
          icon={<i className="bi bi-pencil-square me-1" />}
          text=" Edit Status"
        />
      </div>
      <Accordion
        activeKey={activeKeys}
        alwaysOpen
        className="m-4"
        style={{
          backgroundColor: "white",
          color: "#000",
        }}
      >
        {/* Job Details */}
        <Accordion.Item eventKey="0" className="mt-4 cardShadow">
          <Accordion.Header onClick={() => toggleAccordion("0")}>
            <span
              style={{
                borderLeft: "4px solid orange",
                paddingLeft: "10px",
                fontWeight: "600",
              }}
            >
              Job Details
            </span>
          </Accordion.Header>
          <Accordion.Body>
            <Row>
              <Col md={4} className="mb-2">
                {renderField("Job ID", data.job_id)}
              </Col>
              <Col md={4} className="mb-2">
                {renderField("Role", data.role)}
              </Col>
              <Col md={4} className="mb-2">
                {renderField("Location", data.location)}
              </Col>
              <Col md={4} className="mb-2">
                {renderField("Years of Experience", data.experience)}
              </Col>
              <Col md={4} className="mb-2">
                {renderField("Work Arrangement", data.work_arrangement)}
              </Col>
              <Col md={4} className="mb-2">
                {renderField("Posted Date", data.posted_date)}
              </Col>
              <Col md={4} className="mb-2">
                {renderField(
                  "Skills Set",
                  <div className="text-break white-space-normal word-break-custom">
                    {Array.isArray(data.skills)
                      ? data.skills.join(", ")
                      : data.skills || "-"}
                  </div>,
                )}
              </Col>
              <Col md={4} className="mb-2">
                {renderField("Department", data.department)}
              </Col>
              <Col md={4} className="mb-2">
                {renderField("Job Status", data.job_status)}
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>

        {/* Personal Details */}
        <Accordion.Item eventKey="1" className="mt-4 cardShadow">
          <Accordion.Header onClick={() => toggleAccordion("1")}>
            <span
              style={{
                borderLeft: "4px solid orange",
                paddingLeft: "10px",
                fontWeight: "600",
              }}
            >
              Personal Details
            </span>
          </Accordion.Header>
          <Accordion.Body>
            <Row>
              <Col md={4} className="mb-2">
                {renderField("Name", data.name)}
              </Col>
              <Col md={4} className="mb-2">
                {renderField("Email Address", data.email)}
              </Col>
              <Col md={4} className="mb-2">
                {renderField("Phone Number", data.phone)}
              </Col>
              <Col md={4} className="mb-2">
                {renderField("City", data.city)}
              </Col>
              <Col md={4} className="mb-2">
                {renderField("State", data.state)}
              </Col>
              <Col md={4} className="mb-2">
                {renderField("Country", data.country)}
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>

        {/* Professional Details */}
        <Accordion.Item eventKey="2" className="mt-4 cardShadow">
          <Accordion.Header onClick={() => toggleAccordion("2")}>
            <span
              style={{
                borderLeft: "4px solid orange",
                paddingLeft: "10px",
                fontWeight: "600",
              }}
            >
              Professional Details
            </span>
          </Accordion.Header>
          <Accordion.Body>
            <Row>
              <Col md={4} className="mb-2">
                {renderField("Total Experience", data.total_experience)}
              </Col>
              <Col md={4} className="mb-2">
                {renderField("Relocate Willingness", data.relocate)}
              </Col>
              <Col md={4} className="mb-2">
                {renderField("Expected Salary", `${data.salary}`)}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={4} className="mb-2">
                {renderField(
                  "Uploaded CV",
                  data.cv ? (
                    <div className="text-truncate">
                      {/* <i className="bi bi-file-earmark-text me-2"></i>{" "} */}
                      {data.cv_filename}
                    </div>
                  ) : (
                    <div className="text-muted">No CV uploaded</div>
                  ),
                  data.cv ? (
                    // <a
                    //   href={`${API_BASE_URL}/${data.cv}`}
                    //   download
                    //   className="px-2 custom-download-btn"
                    //   title="Download CV"
                    //   target="_blank"
                    //   rel="noopener noreferrer"
                    // >
                    //   <img
                    //     src={Download}
                    //     alt="Download"
                    //     className="download-icon"
                    //   />
                    // </a>
                    <a
                      href={`${API_BASE_URL}/api/${data.cv}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="px-2 custom-download-btn"
                      title="View CV"
                    >
                      <img
                        src={Download}
                        alt="View"
                        className="download-icon"
                      />
                    </a>
                  ) : null,
                )}
              </Col>

              <Col md={4} className="mb-2">
                {renderField(
                  "Uploaded Cover Letter",
                  data.cover_letter ? (
                    <div className="text-truncate">
                      {data.cover_letter_filename}
                    </div>
                  ) : (
                    <div className="text-muted">No cover letter uploaded</div>
                  ),
                  data.cover_letter ? (
                    <a
                      // href={`${API_BASE_URL}/${data.cover_letter}`}
                      // download
                      // className="px-2 custom-download-btn"
                      // title="Download Cover Letter"
                      // target="_blank"
                      // rel="noopener noreferrer"
                      href={`${API_BASE_URL}/api/${data.cover_letter}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="px-2 custom-download-btn"
                      title="View Cover Letter"
                    >
                      <img
                        src={Download}
                        alt="View"
                        className="download-icon"
                      />
                    </a>
                  ) : null,
                )}
              </Col>

              <Col md={4} className="mb-2">
                {renderField("Applied Date", data.applied_date)}
              </Col>
            </Row>

            <Row>
              <Col md={4} className="mb-2">
                {renderField(
                  "Candidate Status",
                  statusMapReverse[data.candidate_status] || "Pending",
                )}
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md={12}>{renderField("Message", data.message)}</Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      {/* Candidate Status Modal */}
      <Modal
        show={showCandidateStatusModal}
        onHide={handleCloseCandidateStatusModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Candidate Approval Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {[
              // "Pending",
              "Reviewing",
              "Shortlisted",
              "Scheduled",
              "On Hold",
              "Offered",
              "Rejected",
            ].map((status) => (
              <Form.Check
                key={status}
                type="radio"
                label={status}
                name="candidateStatus"
                id={`candidateStatus-${status}`}
                value={status}
                checked={selectedCandidateStatus === status}
                onChange={handleCandidateStatusRadioChange}
                className="mb-2 custom-radio"
              />
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            type="button"
            variant="outline-secondary"
            onClick={handleCloseCandidateStatusModal}
            text="Cancel"
          />
          <Buttons
            type="button"
            variant="primary"
            onClick={handleSaveCandidateStatus}
            text="Save"
          />
        </Modal.Footer>
      </Modal>

      {/* Toast Message */}
      <ToastMessage
        show={toast.show}
        onClose={() => setToast({ ...toast, show: false })}
        message={toast.message}
        variant={toast.variant}
      />
    </>
  );
};

export default Candidates_View;
